import { intl } from "dmsbasereact";

/**
 * SAP Request Type Enum
 * Defines the types of requests in SAP communication
 *
 * OUTBOUND (1-9): Requests from LENA to SAP
 * INBOUND (10+): Requests from SAP to LENA
 */
export const SAPRequestType = {
    get 0() { return intl.get("SAPRequestType.Undefined").d("Undefined"); },
    // Outbound (LENA -> SAP)
    get 1() { return intl.get("SAPRequestType.ClientStatusUpdate").d("Client Status Update"); },
    get 2() { return intl.get("SAPRequestType.ClientDataUpdate").d("Client Data Update"); },
    get 3() { return intl.get("SAPRequestType.BuyerInstitutionSync").d("Buyer Institution Sync"); },
    // Inbound (SAP -> LENA)
    get 10() { return intl.get("SAPRequestType.MaterialInbound").d("Material (Inbound)"); },
    get 11() { return intl.get("SAPRequestType.ClientInbound").d("Client (Inbound)"); },
    get 12() { return intl.get("SAPRequestType.WorkOrderInbound").d("Work Order (Inbound)"); },
    get 13() { return intl.get("SAPRequestType.InvoiceInbound").d("Invoice (Inbound)"); },
    get 14() { return intl.get("SAPRequestType.MovementInbound").d("Movement (Inbound)"); },
};

/**
 * SAP Request Status Enum with translations
 * Defines the possible statuses of a SAP request
 */
export const SAPRequestStatusEnum = {
    PENDING: 0,
    SENT: 1,
    ERROR: 2,
};

/**
 * Get translated text for SAP request status
 */
export const getSAPRequestStatusText = (code) => {
    switch (code) {
        case SAPRequestStatusEnum.PENDING:
            return intl.get("Pending").d("Pending");
        case SAPRequestStatusEnum.SENT:
            return intl.get("Sent").d("Sent");
        case SAPRequestStatusEnum.ERROR:
            return intl.get("Error").d("Error");
        default:
            return intl.get("Unknown").d("Unknown");
    }
};

/**
 * Legacy map for backward compatibility
 * Maps status code to translated text
 */
export const SAPRequestStatus = {
    get 0() { return getSAPRequestStatusText(0); },
    get 1() { return getSAPRequestStatusText(1); },
    get 2() { return getSAPRequestStatusText(2); },
};
